import type React from 'react';

interface ErrorPageProps {
  error: Error;
  onGoBack: () => void;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ error, onGoBack }) => {
  return (
    <div className="errorPage">
      <div className="errorPage__message">
        An error occurred while allocating a room token: {error.message}
      </div>
      <button type="button" onClick={onGoBack} className="errorPage__button">
        Go Back
      </button>
    </div>
  );
};
